
import {
  Menu,
  MenuItem,
  Stack,
  useTheme,
  Typography
} from '@mui/material';

import {
  menuUtil,
  useAccessState
} from 'modules/common';

import { CustomIcon } from 'modules/components/layer00';
import {
  RemoveProjectModal,
  SaveProjectModal
} from 'modules/components/layer17';
import React, { useState } from 'react';

export type ProjectMenuProps = menuUtil.IBaseMenuProps & {};

export const FC = (props: ProjectMenuProps) => {

  const theme = useTheme();
  const [
    isVisible,
    setIsVisible
  ] = useState(false);
  const [
    isSaveVisible,
    setIsSaveVisible
  ] = useState(false);
  const access = useAccessState('Project');
  return (
    <>
      <Menu
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        id={props.id}
        open={props.open}
        anchorEl={props.anchorEl ?? null}
        onClose={() => props.handleClose()}
      >
        {access.delete && (
          <MenuItem
            disabled={!access.delete}
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              setIsVisible(() => true);
            }}
          >
            <Stack
              direction='row'
              columnGap='.5rem'
            >
              <CustomIcon.large.FC
                icon='DELETE'
                stroke={!access.delete
                  ? theme.palette.grey[300]
                  : theme.palette.error.main}
              />
              <Typography
                variant='menuItem'
                color={(theme) => {
                  return !access.delete
                    ? theme.palette.grey[300]
                    : theme.palette.error.main;
                }}
              >
                Delete
              </Typography>
            </Stack>
          </MenuItem>
        )}
        {access.update && (
          <MenuItem
            disabled={!access.update}
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              setIsSaveVisible(() => true);
            }}
          >
            <Stack
              direction='row'
              columnGap='.5rem'
            >
              <CustomIcon.large.FC
                icon='EDIT'
                stroke={!access.update
                  ? theme.palette.grey[300]
                  : theme.palette.primary.main}
              />
              <Typography
                variant='menuItem'
                color={(theme) => {
                  return !access.update
                    ? theme.palette.grey[300]
                    : theme.palette.primary.main;
                }}
              >
                Edit
              </Typography>
            </Stack>
          </MenuItem>
        )}
      </Menu>
      {isVisible && (
        <RemoveProjectModal.FC
          id={props.id}
          isVisible={isVisible}
          handleClose={() => {
            props.handleClose();
            setIsVisible(() => false);
          }}
        />
      )}
      {isSaveVisible && (
        <SaveProjectModal.FC
          id={props.id}
          isVisible={isSaveVisible}
          handleClose={() => {
            props.handleClose();
            setIsSaveVisible(() => false);
          }}
        />
      )}
    </>
  );
};
